import tooltip from '../../modules/tooltip';

function renderTooltip(toggle = {}, fromMulti = false) {
  const tooltipObj = tooltip().dx( (toggle && toggle.dx ? toggle.dx : 0))
    .dy((toggle && toggle.dy ? toggle.dy : 0))
    .target(this)
    .fromMulti(fromMulti);
  const container = (this.parent() ? this.parent() : this).__execs__.canvas;
  if(toggle.color) tooltipObj.color(toggle.color);
  if (fromMulti) {
  } else {
    tooltipObj.keyFunc(toggle.key)
      .valueFunc(toggle.value)
      .offsetFunc(toggle.offset)
      .showDiff(toggle.showDiff);
    this.__execs__.tooltip = tooltipObj;
  }
  tooltipObj.render(container.node().parentNode.parentNode);
  return tooltipObj;
}

export default renderTooltip;


// WEBPACK FOOTER //
// ./layouts/default/renderTooltip.js